// extracted by mini-css-extract-plugin
module.exports = {"main":"flavours-base-main-22e76f30","other":"flavours-base-other-fabc3f9d"};